import * as angular from "angular";


angular
  .module('bringoz.admin.commons')
  .filter('bringozTimeByNumbers', bringozTimeByNumbers);

function bringozTimeByNumbers(splitService, moment) {
  return function (data, timeFormat) {
    if (!timeFormat) {
      timeFormat = splitService.getDateAndTimeConfig().time;
    }
    return moment().set({hour: data.hour, minute: data.min}).format(timeFormat);
  };
}
